import React from 'react'
import FashionCover from '../../assets/Images/FashionCover.jpg'

const SectionThree = () => {
   
    return (
        <>
        <div className="flex">
        <div id="blackOverlay" className="w-full min-h-screen absolute opacity-80 bg-black z-0 flex=1"></div>
        <div className="bg-fashion flex flex-row items-center min-h-screen w-full bg-cover bg-center flex-1 ">
        <div className="mx-auto container py-5 lg:pt-20 lg:pb-52 z-0 text-white flex-1">
                <div className="px-4 xl:px-0">
                    <div className="xl:flex items-center justify-between w-full text-color">
                        <div className="flex flex-col items-center xl:block py-4 xl:py-0">
                            <h1 className="text-6xl font-black ">350+</h1>
                            <h2 className="text-3xl pt-5">Outfits Generated</h2>
                        </div>
                        <div className="flex flex-col items-center xl:block py-4 xl:py-0">
                            <h1 className="text-6xl font-black f-f-l">120K</h1>
                            <h2 className=" text-3xl pt-5">Social Interactions</h2>
                        </div>
                        <div className="flex flex-col items-center xl:block py-4 xl:py-0">
                            <h1 className="text-6xl font-black f-f-l">2,500</h1>
                            <h2 className=" text-3xl pt-5">Styles Influenced</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
       </>
    )
}

export default SectionThree 